import type React from 'react'

import {LABELS} from '../constants/labels'
import {TEST_IDS} from '../constants/test-ids'
import {CommentHeaderBadge} from './CommentHeaderBadge'

type Props = {
  viewerDidAuthor?: boolean
}

export const CommentSubjectAuthor: React.FC<Props> = ({viewerDidAuthor}: Props) => {
  return (
    <CommentHeaderBadge
      viewerDidAuthor={viewerDidAuthor}
      ariaLabel={LABELS.commentSubjectAuthoer(viewerDidAuthor ?? false)}
      label={LABELS.commentAuthor}
      testId={TEST_IDS.commentSubjectAuthor}
    />
  )
}

try{ CommentSubjectAuthor.displayName ||= 'CommentSubjectAuthor' } catch {}